import React from 'react';
import { useLocalization } from '../contexts/LocalizationContext';

const PrivacyPolicy: React.FC = () => {
  const { t } = useLocalization();
  
  return (
    <div className="space-y-6 text-sm text-gray-700 leading-relaxed">
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-3">{t.privacyPolicy.title}</h3>
        <p className="text-gray-600 mb-4">{t.privacyPolicy.effectiveDate}</p>
      </div>
      
      <div>
        <h4 className="font-semibold text-gray-900 mb-2">{t.privacyPolicy.sections.controller.title}</h4>
        <p>
          {t.privacyPolicy.sections.controller.content}
        </p>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">{t.privacyPolicy.sections.dataWeProcess.title}</h4>
        <p>
          <strong>{t.privacyPolicy.sections.dataWeProcess.inputData.split(':')[0]}:</strong> {t.privacyPolicy.sections.dataWeProcess.inputData.split(':').slice(1).join(':').trim()}
        </p>
        <p className="mt-2">
          <strong>{t.privacyPolicy.sections.dataWeProcess.logs.split(':')[0]}:</strong> {t.privacyPolicy.sections.dataWeProcess.logs.split(':').slice(1).join(':').trim()}
        </p>
        <p className="mt-2">
          <strong>{t.privacyPolicy.sections.dataWeProcess.optionalContact.split(':')[0]}:</strong> {t.privacyPolicy.sections.dataWeProcess.optionalContact.split(':').slice(1).join(':').trim()}
        </p>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">{t.privacyPolicy.sections.purposeAndLegalBasis.title}</h4>
        <ul className="list-disc list-inside space-y-1">
          {t.privacyPolicy.sections.purposeAndLegalBasis.items.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">{t.privacyPolicy.sections.dataRetention.title}</h4>
        <ul className="list-disc list-inside space-y-1">
          {t.privacyPolicy.sections.dataRetention.items.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">{t.privacyPolicy.sections.dataSharing.title}</h4>
        <ul className="list-disc list-inside space-y-1">
          {t.privacyPolicy.sections.dataSharing.items.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">{t.privacyPolicy.sections.internationalTransfers.title}</h4>
        <p>
          {t.privacyPolicy.sections.internationalTransfers.content}
        </p>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">{t.privacyPolicy.sections.yourRights.title}</h4>
        <p>{t.privacyPolicy.sections.yourRights.description}</p>
        <ul className="list-disc list-inside space-y-1 mt-2">
          {t.privacyPolicy.sections.yourRights.items.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">{t.privacyPolicy.sections.cookiesAnalytics.title}</h4>
        <p>
          {t.privacyPolicy.sections.cookiesAnalytics.content}
        </p>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">{t.privacyPolicy.sections.changes.title}</h4>
        <p>
          {t.privacyPolicy.sections.changes.content}
        </p>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">{t.privacyPolicy.sections.contact.title}</h4>
        <p>
          {t.privacyPolicy.sections.contact.content}
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;